// import '@wix/ricos/css/ricos-viewer.global.css';
import '@wix/ricos/css/all-plugins-viewer.css';

import { RicosViewer } from '@wix/ricos';
import type { ViewerPluginName } from '@wix/ricos/schema-next';
import React from 'react';
import { viewerPlugins } from 'ricos-shared-mocks';

import { useBiCallbacks } from './bi-context';

export const Viewer = ({
  content,
  plugins: pluginNames,
  isMobile,
}: {
  plugins: ViewerPluginName[];
  content: any;
  isMobile?: boolean;
}) => {
  const plugins = pluginNames.map(key => viewerPlugins[key]);
  const biProps = useBiCallbacks();
  return (
    <div className="h-full overflow-auto relative" style={{ padding: '10px 30px 0' }}>
      <RicosViewer
        isMobile={!!isMobile}
        key={pluginNames.join('-')}
        _rcProps={{ helpers: biProps }}
        content={content}
        plugins={plugins}
        baseUrl="https://example.org/"
      />
    </div>
  );
};
